import { useState } from 'react'

import { PartnerConfigContext } from '../PartnerConfigContext/PartnerConfigContext'

import { GetNominationInviteResponse } from '@percent/product-nomination-form/api/nominationForm/nominationForm.types'
import { PartnerConfigContextControllerProps } from './PartnerConfigContextController.types'

export const PartnerConfigContextController = ({
  children,
}: PartnerConfigContextControllerProps) => {
  const [partnerConfig, setPartnerConfig] = useState<
    GetNominationInviteResponse | undefined
  >(undefined)

  return (
    <PartnerConfigContext.Provider value={{ partnerConfig, setPartnerConfig }}>
      {children}
    </PartnerConfigContext.Provider>
  )
}
